import React from "react";
import { useSelector } from "react-redux";
import {
  selectTabData,
  selectTabLoading,
} from "../../../../../../features/dynamicSlice";
import { FaBook } from "react-icons/fa";

const TopCoursesCard = ({ branchIds }) => {
  const topCourseData = useSelector((state) =>
    selectTabData(state, "topCourses")
  );
  const loading = useSelector((state) => selectTabLoading(state, "topCourses"));

  let topCourse = "N/A";
  let totalAdmissions = 0;

  if (!loading && topCourseData) {
    if (branchIds.includes("all")) {
      topCourse = topCourseData.aggregateTopCourse?.courseName || "N/A";
      totalAdmissions = topCourseData.aggregateTopCourse?.count || 0;
    } else {
      const matching = topCourseData.branches?.filter((b) =>
        branchIds.includes(b.branchId)
      );

      const sorted = [...(matching || [])].sort(
        (a, b) => (b.topCourseCount || 0) - (a.topCourseCount || 0)
      );

      if (sorted[0]) {
        topCourse = sorted[0].courseName || "N/A";
        totalAdmissions = sorted[0].topCourseCount || 0;
      }
    }
  }

  return (
    <div className="bg-gradient-to-br from-yellow-500 via-orange-500 to-red-500 text-white rounded-xl shadow-xl p-6 transform hover:scale-105 transition-transform duration-300 ease-in-out w-[20rem]">
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold uppercase tracking-wide">
          Top Course
        </h4>
        <FaBook className="text-2xl" />
      </div>
      <div>
        {loading ? (
          <p className="text-sm animate-pulse">Loading...</p>
        ) : (
          <>
            <p className="text-xl font-semibold">{topCourse}</p>
            <p className="text-sm mt-1">Admissions: {totalAdmissions}</p>
          </>
        )}
      </div>
    </div>
  );
};

export default TopCoursesCard;
